import { useMemo } from 'react';
import { useGetSimpleHierarchyTypes1Query } from '@/api/generated/rest-v4-api';
import { captionText } from '@/utils/caption';

const HIERARCHY_TYPES_QUERY = { filter: ['archived:eq:false'] };

export const useHierarchyTypes = () => {
  const { data, isLoading } = useGetSimpleHierarchyTypes1Query(HIERARCHY_TYPES_QUERY);

  const hierarchyTypes = useMemo(
    () =>
      (data?.result ?? []).flatMap((type) =>
        type.id === undefined ? [] : [{ id: type.id, label: captionText(type.caption) }]
      ),
    [data]
  );

  return { hierarchyTypes, isLoading };
};
